import $ from 'jquery';

$(function () {
  const gNav = $('.c-gnav');
  const parent = $('.js-gNavHasChild');
  const noChild = $('.js-gNavHasNoChild');
  const submenu = $('.js-gNavSubMenu');

  parent.on('mouseenter', function () {
    submenu.hide();
    if (window.matchMedia('(min-width: 1000px)').matches) {
      $(this).next('.js-gNavSubMenu').show();
    }
  });

  gNav.on('mouseleave', function () {
    submenu.hide();
  });

  noChild.on('mouseenter', function () {
    submenu.hide();
  });
});
